import { Dispatch, SetStateAction } from 'react'
import styles from './PromoModal.module.scss'
import { PartnerPromotion } from '@/store/slices/stagesSlice/interfaces'
import { Icon } from '@/components'

export default function PromoModal({
  setIsOpen,
  partnerPromotion,
}: {
  setIsOpen: Dispatch<SetStateAction<boolean>>
  partnerPromotion: PartnerPromotion
}) {

  const {
    partner: {
      name: partnerName,
      additional_info: partnerAdditionalInfo,
      license: { name: licenceName, url: licenseUrl },
      conditions: { name: conditionsName, url: conditionsUrl },
    },
  } = partnerPromotion

  const closeModal = () => setIsOpen(false)

  const isShowLicenseLink = licenceName && licenseUrl
  const isShowConditionsLink = conditionsName && conditionsUrl

  return (
    <div className={styles.overlay} onClick={closeModal}>
      <div className={styles.modal} onClick={event => event.stopPropagation()}>
        <button className={styles.modal__closeButton} onClick={closeModal}>
          <Icon name="close-icon" />
        </button>
        <h2 className={styles.modal__title}>Реклама</h2>
        <h3 className={styles.modal__subtitle}>{partnerName}</h3>
        <p className={styles.modal__paragraph}>{partnerAdditionalInfo}</p>
        {isShowLicenseLink && (
          <a className={styles.modal__link} href={licenseUrl} target="_blank">
            {licenceName}
          </a>
        )}
        {isShowConditionsLink && (
          <a className={styles.modal__link} href={conditionsUrl} target="_blank">
            {conditionsName}
          </a>
        )}
      </div>
    </div>
  )
}
